import { categoryNames } from 'components/common/JobProfileWidget/text'

const getCategories = (names: ReturnType<typeof categoryNames>) => [
  ...new Set(
    Object.values(names).map(
      ([_label, _description, _explanation, category]) => category,
    ),
  ),
]

const getContent = language =>
  Object.entries(categoryNames(language)).reduce(
    (acc, [name, [label, description, explanation, category]]) => ({
      ...acc,
      [name]: { category, description, explanation, label },
    }),
    {},
  )

export const getCategoryOrder = language => {
  const [first, second, third, fourth, fifth, sixth, seventh] = getCategories(
    categoryNames(language),
  )

  return [first, third, second, fifth, sixth, fourth, seventh]
}

export const getCompetencies = (fields, language) =>
  fields.map(({ name, ...rest }) => ({
    ...{ name, ...rest },
    ...getContent(language)[name],
  }))

export const getIsCompetenciesDisabled = formState => {
  const selectedCompetencies = formState.defaultValues.competencies?.filter(
    (competency, index) => {
      const dirtyFields = formState?.dirtyFields?.competencies
      const dirtyFieldsValue = dirtyFields
        ? (dirtyFields[index] || {})[competency.name]
        : false

      const hasChanged = !!dirtyFieldsValue

      return hasChanged !== competency[competency.name]
    },
  )

  return selectedCompetencies.length >= 5
}

export const getIsCompetencySelected = (name, formState) => {
  const defaultValue = formState?.defaultValues?.competencies?.filter(
    competency => competency.name === name,
  )[0][name]

  const isDirtyField =
    formState?.dirtyFields?.competencies?.filter(competency => competency[name])
      .length === 1

  return defaultValue !== isDirtyField
}
